// removed by extract-text-webpack-plugin
module.exports = {"cookie":"index__cookie___37oug","sectionBottom":"index__sectionBottom___21rSU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/organisms/Cookie/index.css
// module id = 1021
// module chunks = 37